module.exports = __webpack_public_path__ + "img/SuperOK-Boom.693ab68e.png";